import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex justify-center" }
const _hoisted_2 = { class: "w-full h-[40vh] md:h-[50vh] lg:h-[76vh]" }
const _hoisted_3 = {
  ref: "player",
  class: "video-js vjs-theme-fantasy"
}
const _hoisted_4 = { class: "p-5" }
const _hoisted_5 = { class: "grid grid-cols-12 items-center gap-5" }
const _hoisted_6 = { class: "col-span-12 md:col-span-3 flex justify-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "col-span-12 md:col-span-9 flex flex-col gap-5" }
const _hoisted_9 = { class: "flex flex-wrap justify-between gap-3 items-center" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "flex gap-2 items-center justify-center mt-5 text-xs text-gray-600 transition-all animate-errorBlink" }
const _hoisted_12 = { class: "flex mt-5 justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Attention = _resolveComponent("Attention")!
  const _component_MessageVoice = _resolveComponent("MessageVoice")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.hasAttention)
      ? (_openBlock(), _createBlock(_component_Attention, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("video", _hoisted_3, null, 512)
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.confirmModal,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.confirmModal) = $event)),
      closable: false,
      draggable: false,
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '50vw' },
      modal: true,
      showHeader: false,
      contentStyle: "background-color: #E0EFFF;border-bottom:0.4rem solid #d2b604;border-radius:0.5rem;padding:0",
      onHide: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeModalAttention()))
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: require('@/assets/images/avatares/repproved.gif'),
                class: "w-4/6 md:w-5/6 rounded-full",
                alt: "repproved img",
                loading: "lazy"
              }, null, 8, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.$t("attention.title", { user: _ctx.user?.firstName })), 1),
                _createVNode(_component_MessageVoice, {
                  msg: _ctx.attentionText(),
                  class: "w-fit"
                }, null, 8, ["msg"])
              ]),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("attention.subtitle")), 1),
              _createElementVNode("p", _hoisted_11, [
                _createVNode(_component_v_icon, {
                  name: "hi-information-circle",
                  scale: 1.2
                }, null, 8, ["scale"]),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("attention.info")), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_Button, {
              label: _ctx.$t('attention.accept'),
              class: "btn-primary p-button-sm h-10",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModalAttention()))
            }, null, 8, ["label"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}